export default __webpack_public_path__ + "static/media/jd.1d3ab38e.png";